import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { EarningsReportFilter } from "../../components/Reports/EarningsReport/EarningsReportFilter";
import { EarningsReportSummary } from "../../components/Reports/EarningsReport/EarningsReportSummary";
import { EarningsReportTransactions } from "../../components/Reports/EarningsReport/EarningsReportTransactions";
import { Page } from "../Page";

export const EarningsReportPage = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push("/reports/earningsReport");
    };

    return (
        <Page title="Earnings Report">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Earnings Report</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <EarningsReportFilter />
                    <EarningsReportSummary />
                    <EarningsReportTransactions />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
